import React from 'react';
import { Box, Checkbox, Grid, GridItem, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../../styles/theme/foundation/colors';

const Field = ({ label, value }) => (
  <GridItem minW={0}>
    <Text color={colors.primaryScale['400']} textStyle="bodyXs500">{label}</Text>
    <Text isTruncated textStyle="bodySm" title={value}>{value}</Text>
  </GridItem>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

const valueOrNa = value => (value === null || value === undefined || value === '' ? 'N/A' : String(value));

const RecordSearchRow = ({ record, isChecked, isDisabled = false, onToggle }) => {
  const recordId = record.insuranceRequirement?.id;
  const checkboxId = `clone-record-${recordId}`;

  return (
    <HStack
      alignItems="center"
      className="RecordSearchRow"
      pb={2}
      pt={2}
      spacing={3}
    >
      <Checkbox
        id={checkboxId}
        isChecked={isChecked}
        isDisabled={isDisabled}
        value={recordId}
        onChange={e => onToggle(recordId, e.target.checked)}
      />
      <Box
        _hover={{ boxShadow: isDisabled ? 'sharp4' : 'hover2' }}
        aria-disabled={isDisabled}
        borderRadius="10px"
        boxShadow="sharp4"
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        data-cy={`clone-record-row-${recordId}`}
        flex="1 1 auto"
        layerStyle="panel"
        minW={0}
        opacity={isDisabled ? 0.5 : 1}
        px={4}
        py={3}
        role="button"
        onClick={() => !isDisabled && onToggle(recordId, !isChecked)}
      >
        <Text isTruncated mb={1} textStyle="bodyMd500" title={record.insured?.companyName}>
          {valueOrNa(record.insured?.companyName)}
        </Text>
        <Grid gap={3} templateColumns="2fr 1fr 1fr">
          <Field label="Project Name" value={valueOrNa(record.job?.name)} />
          <Field label="Project Number" value={valueOrNa(record.job?.number)} />
          <Field label="Record Number" value={valueOrNa(record.insuranceRequirement?.contractNumber)} />
        </Grid>
      </Box>
    </HStack>
  );
};

RecordSearchRow.propTypes = {
  record: PropTypes.shape({
    insured: PropTypes.shape({ id: PropTypes.number, companyName: PropTypes.string }),
    job: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string, number: PropTypes.string }),
    insuranceRequirement: PropTypes.shape({ id: PropTypes.number, contractNumber: PropTypes.string })
  }).isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired
};

export default RecordSearchRow;
